const env = process.env.ENVIRONMENT !== 'PDN' ? 'DEV' : 'PDN'

let url = {
  LOCAL: 'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/nol',
  DEV: 'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/nol',
  PDN: 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/nol',
}[env]

export const SAVE_IMAGE =
  url + '/competition/api/v1/competition-participation-image'

//campaing college
export const postParticipation = url + '/school/api/v1/competition-participation-save'
export const getUsersTop = url + '/school/api/v1/top-key-competition'
export const getCollegesTop = url + '/school/api/v1/top-key-competition-school'
export const getUserTopPosition = url + '/school/api/v1/user-position-top/'
export const getUserCollegeTopPosition = url + '/school/api/v1/school-position-top'
export const getUserParticipation = url + '/school/api/v1/total-key-competition/'
export const getCollegeByCity = url + '/school/api/v1/get-school/'
